import React from 'react';
import { UserCard } from '../../molecules/UserCard';
import { type User } from '../../../services/usersService';

export interface UsersListProps {
  users: User[];
  actionLoading: number | null;
  onActivate: (user: User) => void;
  onDeactivate: (user: User) => void;
  onSendPasswordReset: (user: User) => void;
  onShadowBanClick: (user: User) => void;
}

export const UsersList = ({
  users,
  actionLoading,
  onActivate,
  onDeactivate,
  onSendPasswordReset,
  onShadowBanClick,
}: UsersListProps) => {
  return (
    <div className="space-y-4 mb-6">
      {users.map((user) => (
        <UserCard
          key={user.id}
          user={user}
          actionLoading={actionLoading}
          onActivate={onActivate}
          onDeactivate={onDeactivate}
          onSendPasswordReset={onSendPasswordReset}
          onShadowBanClick={onShadowBanClick}
        />
      ))}
    </div>
  );
};
